/* eslint-disable no-useless-escape */
// eslint-disable-next-line no-undef
tinymce.addI18n("ro_RO", {
  Redo: "Refacere",
  Undo: "Anulare",
  Cut: "Decupare",
  Copy: "Copiere",
  Paste: "Lipire",
  "Select all": "Selecteaz\u0103 tot",
  "New document": "Document nou",
  Ok: "Ok",
  Cancel: "Revocare",
  "Visual aids": "Ajutoare vizuale",
  Bold: "Aldin",
  Italic: "Cursiv",
  Underline: "Subliniere",
  Strikethrough: "T\u0103iere",
  Superscript: "Exponent",
  Subscript: "Indice",
  "Clear formatting": "\u00cendep\u0103rtare formatare",
  "Align left": "Aliniere st\u00e2nga",
  "Align center": "Aliniere centru",
  "Align right": "Aliniere dreapta",
  Justify: "Aliniere st\u00e2nga-dreapta",
  "Bullet list": "List\u0103 marcatori",
  "Numbered list": "List\u0103 numerotat\u0103",
  "Decrease indent": "Mic\u0219orare indent",
  "Increase indent": "M\u0103rire indent",
  Close: "\u00cenchidere",
  Formats: "Formate",
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.":
    "Browser-ul dumneavoastr\u0103 nu are acces direct la clipboard. V\u0103 rug\u0103m s\u0103 folosi\u021bi \u00een schimb scurt\u0103turile de tastatur\u0103 Ctrl+X/C/V.",
  Headers: "Antete",
  "Header 1": "Antet 1",
  "Header 2": "Antet 2",
  "Header 3": "Antet 3",
  "Header 4": "Antet 4",
  "Header 5": "Antet 5",
  "Header 6": "Antet 6",
  Headings: "Rubrici",
  "Heading 1": "Titlu 1",
  "Heading 2": "Titlu 2",
  "Heading 3": "Titlu 3",
  "Heading 4": "Titlu 4",
  "Heading 5": "Titlu 5",
  "Heading 6": "Titlu 6",
  Preformatted: "Preformatat",
  Div: "Div",
  Pre: "Pre",
  Code: "Cod",
  Paragraph: "Paragraf",
  Blockquote: "Blockquote",
  Inline: "\u00cen linie",
  Blocks: "Blocuri",
  "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.":
    "Lipirea este \u00een mod text simplu. Con\u021binutul va fi lipit ca text simplu p\u00e2n\u0103 dezactiva\u021bi aceast\u0103 op\u021biune.",
  Fonts: "Fonturi",
  "Font Sizes": "Dimensiuni font",
  Class: "Clas\u0103",
  "Browse for an image": "C\u0103uta\u021bi o imagine",
  OR: "SAU",
  "Drop an image here": "Glisa\u021bi o imagine aici",
  Upload: "\u00cenc\u0103rcare",
  Block: "Sec\u021biune",
  Align: "Aliniere",
  Default: "Implicit",
  Circle: "Cerc",
  Disc: "Disc",
  Square: "P\u0103trat",
  "Lower Alpha": "Litere mici",
  "Lower Greek": "Grecesc mic",
  "Lower Roman": "Cifre romane mici",
  "Upper Alpha": "Litere mari",
  "Upper Roman": "Cifre romane mari",
  "Anchor...": "Ancor\u0103\u2026",
  Name: "Nume",
  Id: "Id",
  "Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.":
    "Id-ul ar trebui s\u0103 \u00eenceap\u0103 cu o liter\u0103, urmat\u0103 doar de litere, numere, cratime, puncte, virgule sau sublinieri.",
  "You have unsaved changes are you sure you want to navigate away?":
    "Ave\u021bi modific\u0103ri nesalvate. Sigur dori\u021bi s\u0103 naviga\u021bi \u00een alt\u0103 parte?",
  "Restore last draft": "Restabili\u021bi ultima ciorn\u0103",
  "Special characters...": "Caractere speciale\u2026",
  "Source code": "Cod surs\u0103",
  "Insert/Edit code sample": "Inserare/Editare mostr\u0103 cod",
  Language: "Limb\u0103",
  "Code sample...": "Mostr\u0103 cod\u2026",
  "Color Picker": "Selector culori",
  R: "R",
  G: "G",
  B: "B",
  "Left to right": "St\u00e2nga la dreapta",
  "Right to left": "Dreapta la st\u00e2nga",
  "Emoticons...": "Emoticoane\u2026",
  "Metadata and Document Properties":
    "Meta date \u0219i Propriet\u0103\u021bi Document",
  Title: "Titlu",
  Keywords: "Cuvinte cheie",
  Description: "Descriere",
  Robots: "Robo\u0163i",
  Author: "Autor",
  Encoding: "Codare",
  Fullscreen: "Ecran complet",
  Action: "Ac\u0163iune",
  Shortcut: "Comand\u0103 rapid\u0103",
  Help: "Ajutor",
  Address: "Adres\u0103",
  "Focus to menubar": "Centrare pe bara de meniuri",
  "Focus to toolbar": "Centrare pe bara de unelte",
  "Focus to element path": "Centrare pe calea elementului",
  "Focus to contextual toolbar": "Centrare pe bara de unelte contextual\u0103",
  "Insert link (if link plugin activated)":
    "Inserare link (dac\u0103 modulul de link-uri este activat)",
  "Save (if save plugin activated)":
    "Salvare (dac\u0103 modulul de salvare este activat)",
  "Find (if searchreplace plugin activated)":
    "C\u0103utare (dac\u0103 modulul de c\u0103utare \u0219i \u00eenlocuire este activat)",
  "Plugins installed ({0}):": "Module instalate ({0}):",
  "Premium plugins:": "Module premium:",
  "Learn more...": "Afla\u021bi mai multe\u2026",
  "You are using {0}": "Folosi\u021bi {0}",
  Plugins: "Inserturi",
  "Handy Shortcuts": "Comenzi rapide accesibile",
  "Horizontal line": "Linie orizontal\u0103",
  "Insert/edit image": "Inserare/editare imagini",
  "Image description": "Descriere imagine",
  Source: "Surs\u0103",
  Dimensions: "Dimensiuni",
  "Constrain proportions": "Restric\u021bionare propor\u021bii",
  General: "General",
  Advanced: "Complex",
  Style: "Stil",
  "Vertical space": "Spa\u0163iu vertical",
  "Horizontal space": "Spa\u0163iu orizontal",
  Border: "Chenar",
  "Insert image": "Inserare imagine",
  "Image...": "Imagine\u2026",
  "Image list": "List\u0103 de imagini",
  "Rotate counterclockwise": "Rotire invers sensului acelor de ceasornic",
  "Rotate clockwise": "Rotire \u00een sensul acelor de ceasornic",
  "Flip vertically": "Inversare vertical\u0103",
  "Flip horizontally": "Inversare orizontal\u0103",
  "Edit image": "Editare imagine",
  "Image options": "Op\u021biuni imagine",
  "Zoom in": "Apropiere",
  "Zoom out": "Dep\u0103rtare",
  Crop: "Decupare",
  Resize: "Redimensionare",
  Orientation: "Orientare",
  Brightness: "Luminozitate",
  Sharpen: "Accentuare",
  Contrast: "Contrast",
  "Color levels": "Niveluri culori",
  Gamma: "Gamma",
  Invert: "Inversare",
  Apply: "Aplicare",
  Back: "\u00cenapoi",
  "Insert date/time": "Inserare dat\u0103/or\u0103",
  "Date/time": "Dat\u0103/or\u0103",
  "Insert/Edit Link": "Inserare/Editare link",
  "Insert/edit link": "Inserare/editare link",
  "Text to display": "Text de afi\u0219at",
  Url: "Url",
  "Open link in...": "Deschide link \u00een\u2026",
  "Current window": "Fereastra curent\u0103",
  None: "Nu se utilizeaz\u0103 (acest c\u00e2mp)",
  "New window": "Fereastr\u0103 nou\u0103",
  "Remove link": "Eliminare link",
  Anchors: "Ancore",
  "Link...": "Link\u2026",
  "Paste or type a link": "Lipi\u021bi sau scrie\u021bi un link",
  "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?":
    "URL-ul introdus pare a fi o adres\u0103 de e-mail. Dori\u021bi s\u0103 ad\u0103uga\u021bi prefixul mailto: necesar?",
  "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?":
    "URL-ul introdus pare a fi un link extern. Dori\u021bi s\u0103 ad\u0103uga\u021bi prefixul http:// necesar?",
  "Link list": "List\u0103 linkuri",
  "Insert video": "Inserare video",
  "Insert/edit video": "Inserare/editare video",
  "Insert/edit media": "Inserare/editare media",
  "Alternative source": "Surs\u0103 alternativ\u0103",
  "Alternative source URL": "URL surs\u0103 alternativ\u0103",
  "Media poster (Image URL)": "Poster media (URL imagine)",
  "Paste your embed code below:":
    "Lipi\u021bi codul de \u00eencorporare mai jos:",
  Embed: "\u00cencorporare",
  "Media...": "Media\u2026",
  "Nonbreaking space": "Spa\u021biu f\u0103r\u0103 \u00eentreruperi",
  "Page break": "\u00centrerupere de pagin\u0103",
  "Paste as text": "Lipire ca text",
  Preview: "Previzualizare",
  "Print...": "Tip\u0103rire\u2026",
  Save: "Salvare",
  Find: "G\u0103sire",
  "Replace with": "\u00cenlocuire cu",
  Replace: "\u00cenlocuire",
  "Replace all": "\u00cenlocuire peste tot",
  Previous: "Anterior",
  Next: "Urm\u0103torul",
  "Find and replace...": "C\u0103utare \u0219i \u00eenlocuire\u2026",
  "Could not find the specified string.":
    "Nu s-a g\u0103sit \u0219irul indicat.",
  "Match case": "Potrivire litere mari \u0219i mici",
  "Find whole words only": "G\u0103se\u0219te doar cuvintele \u00eentregi",
  "Spell check": "Verificare ortografic\u0103",
  Ignore: "Ignorare",
  "Ignore all": "Ignor\u0103 tot",
  Finish: "Finalizare",
  "Add to Dictionary": "Ad\u0103ugare \u00een Dic\u021bionar",
  "Insert table": "Inserare tabel",
  "Table properties": "Propriet\u0103\u021bi tabel",
  "Delete table": "Eliminare tabel",
  Cell: "Celul\u0103",
  Row: "R\u00e2nd",
  Column: "Coloan\u0103",
  "Cell properties": "Propriet\u0103\u021bi celul\u0103",
  "Merge cells": "\u00cembinare celule",
  "Split cell": "Scindare celul\u0103",
  "Insert row before": "Inserare r\u00e2nd \u00eenainte",
  "Insert row after": "Inserare r\u00e2nd dup\u0103",
  "Delete row": "Eliminare r\u00e2nd",
  "Row properties": "Propriet\u0103\u021bi r\u00e2nd",
  "Cut row": "Decupare r\u00e2nd",
  "Copy row": "Copiere r\u00e2nd",
  "Paste row before": "Lipire r\u00e2nd \u00eenainte",
  "Paste row after": "Lipire r\u00e2nd dup\u0103",
  "Insert column before": "Inserare coloan\u0103 \u00eenainte",
  "Insert column after": "Inserare coloan\u0103 dup\u0103",
  "Delete column": "Eliminare coloan\u0103",
  Cols: "Coloane",
  Rows: "R\u00e2nduri",
  Width: "L\u0103\u021bime",
  Height: "\u00cen\u0103l\u021bime",
  "Cell spacing": "Spa\u021biere celul\u0103",
  "Cell padding": "Spa\u021biere \u00een celul\u0103",
  "Show caption": "Afi\u0219are captur\u0103",
  Left: "St\u00e2nga",
  Center: "Centru",
  Right: "Dreapta",
  "Cell type": "Tip celul\u0103",
  Scope: "Domeniu",
  Alignment: "Aliniere",
  "H Align": "Aliniere O",
  "V Align": "Aliniere V",
  Top: "Sus",
  Middle: "Mijloc",
  Bottom: "Jos",
  "Header cell": "Celul\u0103 de antet",
  "Row group": "Grupare r\u00e2nduri",
  "Column group": "Grup coloane",
  "Row type": "Tip r\u00e2nd",
  Header: "Antet",
  Body: "Corp",
  Footer: "Subsol de pagin\u0103",
  "Border color": "Culoare chenar",
  "Insert template...": "Inserare \u0219ablon\u2026",
  Templates: "\u0218abloane",
  Template: "\u0218ablon",
  "Text color": "Culoare text",
  "Background color": "Culoare fundal",
  "Custom...": "Particularizare...",
  "Custom color": "Culoare personalizat\u0103",
  "No color": "F\u0103r\u0103 culoare",
  "Remove color": "Eliminare culoare",
  "Table of Contents": "Cuprins",
  "Show blocks": "Arat\u0103 rubricile",
  "Show invisible characters": "Arat\u0103 caracterele invizibile",
  "Word count": "Num\u0103r\u0103toare cuvinte",
  "Words: {0}": "Cuvinte: {0}",
  "{0} words": "{0} cuvinte",
  File: "Fi\u0219ier",
  Edit: "Editare",
  Insert: "Inserare",
  View: "Vizualizare",
  Format: "Formatare",
  Table: "Tabel",
  Tools: "Unelte",
  "Powered by {0}": "Sus\u021binut de {0}",
  "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help":
    "Zon\u0103 Text Formatat. Ap\u0103sa\u021bi ALT-F9 pentru a accesa meniul. Ap\u0103sa\u021bi ALT-F10 pentru a accesa bara de unelte. Ap\u0103sa\u021bi ALT-0 pentru ajutor",
  "Image title": "Titlu imagine",
  "Border width": "Grosime chenar",
  "Border style": "Stil chenar",
  Error: "Eroare",
  Warn: "Aten\u021bionare",
  Valid: "Valid",
  "To open the popup, press Shift+Enter":
    "Pentru a deschide fereastra popup, ap\u0103sa\u021bi Shift+Enter",
  "Rich Text Area. Press ALT-0 for help.":
    "Zon\u0103 Text Formatat. Ap\u0103sa\u021bi ALT-0 pentru ajutor.",
  "System Font": "Font Sistem",
  "Failed to upload image: {0}": "Nu s-a putut \u00eenc\u0103rca imaginea: {0}",
  "Failed to load plugin: {0} from url {1}":
    "Nu s-a putut \u00eenc\u0103rca modulul: {0} de la URL-ul {1}",
  "Failed to load plugin url: {0}":
    "Nu s-a putut \u00eenc\u0103rca URL-ul modulului: {0}",
  "Failed to initialize plugin: {0}":
    "Nu s-a putut ini\u021bializa modulul: {0}",
  example: "exemplu",
  Search: "C\u0103utare",
  All: "Tot",
  Currency: "Moned\u0103",
  Text: "Text",
  Quotations: "Ghilimele",
  Mathematical: "Simboluri matematice",
  "Extended Latin": "Simboluri alfabet latin extins",
  Symbols: "Simboluri",
  Arrows: "S\u0103ge\u021bi",
  "User Defined": "Definite de utilizator",
  "dollar sign": "simbol dolar",
  "currency sign": "simbol moned\u0103",
  "euro-currency sign": "simbol euro",
  "colon sign": "dou\u0103 puncte",
  "cruzeiro sign": "simbol cruzeiro",
  "french franc sign": "simbol franc francez",
  "lira sign": "simbol lir\u0103",
  "mill sign": "simbol mill",
  "naira sign": "simbol naira",
  "peseta sign": "simbol peset\u0103",
  "rupee sign": "simbol rupie",
  "won sign": "simbol won",
  "new sheqel sign": "simbol shekel nou",
  "dong sign": "simbol dong",
  "kip sign": "simbol kip",
  "tugrik sign": "simbol tugrik",
  "drachma sign": "simbol drahm\u0103",
  "german penny symbol": "simbol peni german",
  "peso sign": "simbol peso",
  "guarani sign": "simbol guarani",
  "austral sign": "simbol austral",
  "hryvnia sign": "simbol grivn\u0103",
  "cedi sign": "simbol cedi",
  "livre tournois sign": "simbol livr\u0103 tournois",
  "spesmilo sign": "simbol spesmilo",
  "tenge sign": "simbol tenge",
  "indian rupee sign": "simbol rupie indian\u0103",
  "turkish lira sign": "simbol lir\u0103 turceasc\u0103",
  "nordic mark sign": "simbol marc\u0103 nordic\u0103",
  "manat sign": "simbol manat",
  "ruble sign": "simbol rubl\u0103",
  "yen character": "simbol yen",
  "yuan character": "simbol yuan",
  "yuan character, in hong kong and taiwan":
    "simbol yuan \u00een Hong Kong \u0219i Taiwan",
  "yen/yuan character variant one": "simbol yen/yuan prima variant\u0103",
  "Loading emoticons...": "Se \u00eencarc\u0103 emoticoanele\u2026",
  "Could not load emoticons": "Nu s-au putut \u00eenc\u0103rca emoticoanele",
  People: "Persoane",
  "Animals and Nature": "Animale \u0219i natur\u0103",
  "Food and Drink": "M\u00e2ncare \u0219i b\u0103uturi",
  Activity: "Activit\u0103\u021bi",
  "Travel and Places": "C\u0103l\u0103torii \u0219i loca\u021bii",
  Objects: "Obiecte",
  Flags: "Steaguri",
  Characters: "Caractere",
  "Characters (no spaces)": "Caractere (f\u0103r\u0103 spa\u021bii)",
  "Error: Form submit field collision.":
    "Eroare: Coliziune c\u00e2mpuri la trimiterea formularului.",
  "Error: No form element found.":
    "Eroare: Niciun element de formular g\u0103sit.",
  Update: "Actualizare",
  "Color swatch": "Mostr\u0103 de culori",
  Turquoise: "Turcoaz",
  Green: "Verde",
  Blue: "Albastru",
  Purple: "Mov",
  "Navy Blue": "Albastru marin",
  "Dark Turquoise": "Turcoaz \u00eenchis",
  "Dark Green": "Verde \u00eenchis",
  "Medium Blue": "Albastru mediu",
  "Medium Purple": "Mov mediu",
  "Midnight Blue": "Albastru \u00eenchis",
  Yellow: "Galben",
  Orange: "Portocaliu",
  Red: "Ro\u0219u",
  "Light Gray": "Gri deschis",
  Gray: "Gri",
  "Dark Yellow": "Galben \u00eenchis",
  "Dark Orange": "Portocaliu \u00eenchis",
  "Dark Red": "Ro\u0219u \u00eenchis",
  "Medium Gray": "Gri mediu",
  "Dark Gray": "Gri \u00eenchis",
  Black: "Negru",
  White: "Alb",
  "Switch to or from fullscreen mode":
    "Comutare pe sau de la modul ecran complet",
  "Open help dialog": "Deschide dialogul de ajutor",
  history: "istoric",
  styles: "stiluri",
  formatting: "formatare",
  alignment: "aliniere",
  indentation: "indentare",
  "permanent pen": "stilou permanent",
  comments: "comentarii",
});
